module.exports = __webpack_public_path__ + "static/media/icons-arrows-buttons-right-arrow-dark-gray.9a191558.svg";